<template>
  <div class="absolute fill-height events-page">
    <v-dialog
      v-model="dialogUploadDocument"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogUploadDocument"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2 v-if="invoiceNeedsApproval">Nahrát fakturu ke spolupracovníkovi</h2>
          <h2 v-else>Nahrát fakturu ke spolupracovníkovi k odsouhlasení</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <vue-dropzone :options="dropzoneOptions" :id="'dropzone'" :useCustomSlot="true" style="min-height: 120px;">
            <v-card class="elevation-1" color="grey lighten-4 dropzone-clickable">
              <v-card-text class="pt-3 text-xs-left">
                <div>

                </div>
                <p class="pt-5 pb-4 text-xs-center">Nahrajte přetažením souboru z počítače</p>
              </v-card-text>
            </v-card>
          </vue-dropzone>
          <div hidden id="dropzone-preview"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogUploadDocument=false" :loading="uploading">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <div>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Obchody a&nbsp;provize</h3>
                </v-flex>
              </v-layout>
            </div>
            <v-layout row wrap class="mt-3" :class="{'mx-3':$vuetify.breakpoint.smAndUp}">
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Provize celkem:</p>
                <p class="mt-0"><strong>{{obdobi_data.celkem_castka | formatMoney}} Kč</strong></p>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Kredity celkem:</p>
                <p class="mt-0"><strong>{{obdobi_data.celkem_kredity | formatMoney}} kr.</strong></p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" :class="{'mx-3':$vuetify.breakpoint.smAndUp}">
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Vlastní provize:</p>
                <p class="mt-0"><strong>{{obdobi_data.vlastni_castka | formatMoney}} Kč</strong></p>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Skupinová provize:</p>
                <p class="mt-0"><strong>{{obdobi_data.skupinova_castka | formatMoney}} Kč</strong></p>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Vlastní kredity:</p>
                <p class="mt-0"><strong>{{obdobi_data.vlastni_kredity | formatMoney}} kr.</strong></p>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Skupinové kredity:</p>
                <p class="mt-0"><strong>{{obdobi_data.skupinove_kredity | formatMoney}} kr.</strong></p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" :class="{'mx-3':$vuetify.breakpoint.smAndUp}">
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Stupeň kariéry:</p>
                <p class="mt-0"><strong>{{obdobi_data.pozice}}</strong></p>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Odměna za kredit:</p>
                <p class="mt-0"><strong>{{obdobi_data.hodnota_kreditu | formatInt}} Kč</strong></p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" :class="{'mx-3':$vuetify.breakpoint.smAndUp}">
              <v-flex xs12 sm6 md2>
                <p class="mb-1">Stav:</p>
                <p class="mt-0">
                  <strong>
                    <span v-if="obdobi_data.faktura_odsouhlasena && !obdobi_data.faktura_schvalovani && obdobi_data.obdobi_ukonceno" class="bold green--text">Odsouhlaseno</span>
                    <span v-else-if="!obdobi_data.faktura_odsouhlasena && !obdobi_data.faktura_schvalovani && obdobi_data.obdobi_ukonceno" class="bold red--text">Neodsouhlaseno</span>
                    <span v-else-if="obdobi_data.faktura_schvalovani && obdobi_data.obdobi_ukonceno">Probíhá schvalování</span>
                    <span v-else-if="!obdobi_data.obdobi_ukonceno">Období neukončeno</span>
                  </strong>
                </p>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" :class="{'mx-3':$vuetify.breakpoint.smAndUp}">
              <v-flex xs12>
                <div>
                  <a :href="$salesmanInvoicesBaseUrl + obdobi_data.fa_s3_nazev" v-if="obdobi_data.fa_s3_nazev != null" target="_blank">
                    <v-btn color="primary" depressed class="ma-0">
                      <v-icon class="mr-2">cloud_download</v-icon> Stáhnout fakturu
                    </v-btn>
                  </a>
                  <v-btn color="grey lighten-3" v-else depressed @click="uploadInvoiceClick()" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon class="mr-2">cloud_upload</v-icon> Nahrát fakturu</v-btn>
                  <v-menu bottom right offset-y>
                    <v-btn color="transparent" dark slot="activator" depressed class="black--text ma-0" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon>more_vert</v-icon> Další možnosti</v-btn>
                    <v-list>
                      <v-list-tile @click="uploadInvoiceClick()" v-if="obdobi_data.fa_s3_nazev != null">
                        <v-list-tile-title>Znovu nahrát fakturu</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="uploadInvoiceClickNeedApproval()">
                        <v-list-tile-title>Nahrát fakturu k odsouhlasení</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </v-flex>
            </v-layout>
            <div class="mt-3">
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :pagination.sync="pagination"
                  :total-items="pagination.totalItems"
                  :rows-per-page-items="[25, 50, 100, 200]"
                  item-key="i"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.datum | formatDate }}</td>
                    <td>{{ props.item.spolupracovnik.nazev_osoby }}</td>
                    <td>{{ props.item.klient.nazev_osoby }}</td>
                    <td>{{ props.item.popis }}</td>
                    <td class="text-xs-right">{{ props.item.castka }} {{props.item.mena.zkratka}}</td>
                    <td class="text-xs-right">{{ props.item.kredity | formatDouble }}</td>
                    <td class="text-xs-right">{{ props.item.pozice_hodnota_kreditu }} Kč</td>
                    <td class="text-xs-right">{{ props.item.provize | formatMoney }} Kč</td>
                    <!--<td>{{ props.item.stav }}</td>-->
                    <td class="text-center">
                      <router-link :to="{ path: '/admin/obchody-a-provize/' + props.item.id }" target="_blank">
                        <v-btn color="primary" class="elevation-0">
                        <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                      </router-link>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Spolupracovník', value: 'spolupracovnik' },
        { text: 'Klient', value: 'klient' },
        { text: 'Typ obchodu', value: 'typ_obchodu' },
        { text: 'Částka', value: 'castka', align: 'right' },
        { text: 'Kredity', value: 'kredity', align: 'right' },
        { text: 'Hodnota kreditu', value: 'pozice_hodnota_kreditu', align: 'right' },
        { text: 'Provize', value: 'provize', align: 'right' },
        //{ text: 'Stav', value: 'stav' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      stav: [
        'Otevřeno',
        'Navrženo k vyúčtování',
        'Odsouhlaseno',
        'Fakturováno'
      ],
      obdobiItems: [],
      spolupracovnik: null,
      datum_od: null,
      datum_do: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "datum_sjednani",
        totalItems: 0
      },
      obdobi: null,
      obdobi_data: null,
      dialogUploadDocument: false,
      dropzoneOptions: null,
      activeItem: null,
      uploadedItem: null,
      uploading: false,
      invoiceNeedsApproval: false
    }
  },
  props: {
    id: [ String, Number ]
  },
  watch: {
    spolupracovnik () {
      this.load();
    },
    obdobi () {
      this.load();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    }
  },
  created () {
    var $this = this;
    this.dropzoneOptions = {
      url: window.API.$api_url+"uploader/file",
      clickable: true,
      autoProcessQueue: true,
      uploadMultiple: false,
      parallelUploads: 1,
      addRemoveLinks: true,
      previewsContainer: "#dropzone-preview",
      headers: {
        "AuthToken": window.api.$cookies.get("cc_com_token")
      },
      init: function() {
        this.on("addedfile", function(a, b, c) {
          $this.uploading = true;
        }.bind(this));
        this.on("success", function(a, b, c) {
          if (b.uploaded) {
            $this.uploadedItem = b;
            /*$this.updateItem.dokumenty.push({
              id: b.id,
              nazev: a.name,
              s3_nazev: b.s3_name,
              u: true
            });*/
            $this.putInvoice($this, (state) => {
              if (state) {
                $this.dialogUploadDocument = false;
                $this.obdobi_data.fa_s3_nazev = b.s3_name;
              }
              $this.uploading = false;
            });
          }
        }.bind(this));
      }
    };
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/obchody-provize/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        faktura_obdobi_id: this.id
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        var c = 0;
        this.items.replace(body.data.map((e) => { e.i = c++; return e; }));
        this.obdobi_data = body.obdobi;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    uploadInvoiceClick() {
      this.invoiceNeedsApproval = false;
      this.dialogUploadDocument = true;
    },
    uploadInvoiceClickNeedApproval() {
      this.invoiceNeedsApproval = true;
      this.dialogUploadDocument = true;
    },
    putInvoice($this, f) {
      window.API.put(this.invoiceNeedsApproval ? ("fakturace-provizi/" + $this.id + "/faktura-k-odsouhlaseni") : ("fakturace-provizi/" + $this.id + "/faktura"), {
        soubor_id: $this.uploadedItem.id
      }).then(function(body) {
        if (typeof f === "function")
          f(body.updated);
        if (this.invoiceNeedsApproval) {
          $this.obdobi_data.faktura_schvalovani = true;
          $this.obdobi_data.obdobi_ukonceno = true;
        }
        else {
          $this.obdobi_data.faktura_schvalovani = false;
          $this.obdobi_data.faktura_odsouhlasena = true;
          $this.obdobi_data.obdobi_ukonceno = true;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Fakturace/FakturaceObchodyProvize.vue